// client/src/data/ServicesData.js
import {
  Gavel,
  MonetizationOn,
  HomeWork,
  Description,
  ContactSupport,
  Assignment,
  Business,
  CleaningServices,
  LocalShipping,
  Security,
  Fingerprint,
  Public,
  Build,
  TrendingUp,
  VerifiedUser,
  Speed,
  Receipt,
  CardTravel,
  DocumentScanner,
  Handshake
} from '@mui/icons-material';

export const allServices = [
  // Services juridiques existants
  {
    id: 1,
    title: 'Consultation Juridique',
    shortDesc: 'Conseils juridiques personnalisés par nos experts',
    fullDesc: 'Nos experts juridiques sont à votre service 7j/7 pour toute assistance juridique. Que ce soit pour un contrat, une réglementation, une négociation ou un conseil administratif, nous défendons vos intérêts jusqu\'au bout.',
    icon: <Gavel />,
    image: '/images/consultation.jpg',
    features: ['Droit de la famille', 'Droit du travail', 'Droit des affaires', 'Droit civil', 'Conseil personnalisé'],
    link: '/consultation',
    color: '#1a237e',
    category: 'juridique'
  },
  {
    id: 2,
    title: 'Recouvrement de Créances',
    shortDesc: 'Amiable et judiciaire - Récupérez vos impayés',
    fullDesc: 'Nous vous accompagnons dans le recouvrement de vos créances, que ce soit par voie amiable ou judiciaire. Procédure rapide et efficace.',
    icon: <MonetizationOn />,
    image: '/images/recouvrement.jpg',
    features: ['Recouvrement amiable', 'Injonction de payer', 'Référé provision', 'Assignation au fond'],
    link: '/recouvrement',
    color: '#c2185b',
    category: 'juridique'
  },
  {
    id: 3,
    title: 'Services Immobiliers',
    shortDesc: 'Achat, vente, location et gestion d\'actifs',
    fullDesc: 'Que vous soyez au Togo ou à l\'étranger, nous vous accompagnons dans toutes vos transactions immobilières avec efficacité, sincérité et honnêteté.',
    icon: <HomeWork />,
    image: '/images/immobilier.jpg',
    features: ['Achat/Vente', 'Location', 'Gestion locative', 'Vérification foncière', 'Titres de propriété'],
    link: '/immobilier',
    color: '#f57c00',
    category: 'immobilier'
  },
  {
    id: 4,
    title: 'Formalités Administratives',
    shortDesc: 'Création d\'entreprise, titres fonciers et plus',
    fullDesc: 'Nous vous assistons dans toutes vos formalités administratives : création d\'entreprise, immatriculation foncière, et toutes les démarches officielles.',
    icon: <Description />,
    image: '/images/formalites.jpg',
    features: ['Création d\'entreprise', 'Titre foncier', 'Immatriculation RCCM', 'CNSS', 'Patente'],
    link: '/formalites',
    color: '#0288d1',
    category: 'administratif'
  },

  // NOUVEAUX SERVICES
  {
    id: 5,
    title: 'Montage de Dossiers d\'Appel d\'Offres (DAO)',
    shortDesc: 'Préparation et soumission de dossiers gagnants',
    fullDesc: 'Spécialistes en montage de dossiers d\'appel d\'offres publics et privés. Nous vous aidons à constituer des dossiers complets, conformes et compétitifs pour maximiser vos chances de remporter les marchés.',
    icon: <Assignment />,
    image: '/images/dao.jpg',
    features: ['Analyse des cahiers des charges', 'Constitution des pièces administratives', 'Rédaction des mémoires techniques', 'Soumission en ligne', 'Suivi des dossiers'],
    link: '/consultation',
    color: '#2e7d32',
    category: 'marches'
  },
  {
    id: 6,
    title: 'Consultant en Marchés Publics',
    shortDesc: 'Expertise en commande publique',
    fullDesc: 'Accompagnement complet pour les entreprises souhaitant répondre aux marchés publics. Conseil stratégique, veille réglementaire et assistance tout au long du processus.',
    icon: <TrendingUp />,
    image: '/images/dao.png',
    features: ['Veille des appels d\'offres', 'Stratégie de réponse', 'Aide à la soumission', 'Défense des offres', 'Contentieux des marchés'],
    link: '/consultation',
    color: '#1565c0',
    category: 'marches'
  },
  {
    id: 7,
    title: 'Nettoyage & Entretien',
    shortDesc: 'Locaux professionnels et particuliers',
    fullDesc: 'Services professionnels de nettoyage et d\'entretien pour bureaux, appartements, commerces et espaces industriels. Équipes formées et produits adaptés.',
    icon: <CleaningServices />,
    image: '/images/nettoyage.jpg',
    features: ['Nettoyage de bureaux', 'Entretien d\'appartements', 'Nettoyage industriel', 'Désinfection', 'Vitrerie'],
    link: '/consultation',
    color: '#00acc1',
    category: 'prestations'
  },
  {
    id: 8,
    title: 'Fournitures de Produits d\'Entretien',
    shortDesc: 'Distribution de produits professionnels',
    fullDesc: 'Fourniture de produits d\'entretien de qualité professionnelle pour entreprises, collectivités et particuliers. Large gamme de produits écologiques et certifiés.',
    icon: <LocalShipping />,
    image: '/images/fournitures.jpg',
    features: ['Produits d\'entretien', 'Matériel de nettoyage', 'Livraison à domicile', 'Tarifs entreprises', 'Produits éco-responsables'],
    link: '/consultation',
    color: '#ff6f00',
    category: 'prestations'
  },
  {
    id: 9,
    title: 'Sécurité & Gardiennage',
    shortDesc: 'Protection des biens et des personnes',
    fullDesc: 'Services de sécurité et de gardiennage pour entreprises, résidences, événements et sites sensibles. Agents formés et agréés, surveillance 24h/24.',
    icon: <Security />,
    image: '/images/securite.jpg',
    features: ['Gardiennage', 'Surveillance 24/7', 'Rondes de sécurité', 'Contrôle d\'accès', 'Vidéo protection'],
    link: '/consultation',
    color: '#37474f',
    category: 'prestations'
  },
  {
    id: 10,
    title: 'Casier Judiciaire',
    shortDesc: 'Obtenez votre extrait rapidement',
    fullDesc: 'Demande et obtention de casier judiciaire (bulletin n°3) pour les besoins administratifs, professionnels ou personnels. Traitement rapide et suivi personnalisé.',
    icon: <Fingerprint />,
    image: '/images/casier.jpg',
    features: ['Bulletin n°3', 'Extrait de casier', 'Certificat de nationalité', 'Traduction et légalisation'],
    link: '/consultation',
    color: '#8e24aa',
    category: 'administratif'
  },
  {
    id: 11,
    title: 'Passeport',
    shortDesc: 'Assistance pour l\'obtention du passeport',
    fullDesc: 'Accompagnement complet dans les démarches d\'obtention ou de renouvellement de passeport. Prise de rendez-vous, constitution du dossier et suivi.',
    icon: <CardTravel />,  // Remplacé Passport par CardTravel
    image: '/images/passeport.jpg',
    features: ['Nouvelle demande', 'Renouvellement', 'Passeport enfants', 'Urgence', 'Suivi de dossier'],
    link: '/consultation',
    color: '#00695c',
    category: 'administratif'
  },
  {
    id: 12,
    title: 'Démarches de Nationalité',
    shortDesc: 'Obtenez ou renouvelez votre nationalité',
    fullDesc: 'Assistance juridique et administrative pour les démarches de nationalité : déclaration, naturalisation, réintégration, et toutes les procédures connexes.',
    icon: <Public />,
    image: '/images/nationalite.jpg',
    features: ['Déclaration de nationalité', 'Naturalisation', 'Réintégration', 'Certificat de nationalité', 'Recours contentieux'],
    link: '/consultation',
    color: '#ad1457',
    category: 'administratif'
  },
  {
    id: 13,
    title: 'Intermédiation',
    shortDesc: 'Médiation et résolution de conflits',
    fullDesc: 'Nous intervenons comme médiateur dans les situations conflictuelles pour préserver la cohésion sociale et trouver des solutions amiables.',
    icon: <Handshake />,  // Remplacé ContactSupport par Handshake
    image: '/images/intermediation.jpg',
    features: ['Médiation familiale', 'Conflits professionnels', 'Résolution à l\'amiable'],
    link: '/consultation',
    color: '#1976d2',
    category: 'juridique'
  },
  {
    id: 14,
    title: 'Assistance Sinistre',
    shortDesc: 'Accompagnement après accident',
    fullDesc: 'Nous vous accompagnons dans l\'accomplissement des formalités nécessaires pour obtenir réparation ou dédommagement auprès des assureurs.',
    icon: <VerifiedUser />,
    image: '/images/sinistre.jpg',
    features: ['Accidents de circulation', 'Accidents de travail', 'Indemnisation'],
    link: '/consultation',
    color: '#7b1fa2',
    category: 'juridique'
  },
  {
    id: 15,
    title: 'Rédaction d\'Actes Juridiques',
    shortDesc: 'Contrats, conventions et actes notariés',
    fullDesc: 'Rédaction professionnelle de tous types d\'actes juridiques : contrats, conventions, testaments, reconnaissances de dettes, et plus.',
    icon: <Build />,
    image: '/images/actes.jpg',
    features: ['Contrats commerciaux', 'Conventions', 'Actes sous seing privé', 'Testaments', 'Reconnaissances de dettes'],
    link: '/consultation',
    color: '#00897b',
    category: 'juridique'
  },
  {
    id: 16,
    title: 'Orientation Judiciaire',
    shortDesc: 'Guidage dans les procédures',
    fullDesc: 'Nous vous guidons dans les méandres de la justice et de l\'administration pour adopter la bonne procédure selon votre situation.',
    icon: <Speed />,
    image: '/images/orientation.jpg',
    features: ['Procédures judiciaires', 'Démarches administratives', 'Assistance juridique'],
    link: '/consultation',
    color: '#388e3c',
    category: 'juridique'
  }
];

export const serviceCategories = [
  { id: 'all', label: 'Tous les services', icon: null },
  { id: 'juridique', label: 'Services Juridiques', icon: <Gavel /> },
  { id: 'immobilier', label: 'Immobilier & Gestion', icon: <HomeWork /> },
  { id: 'administratif', label: 'Formalités Administratives', icon: <Description /> },
  { id: 'marches', label: 'Marchés Publics & DAO', icon: <Assignment /> },
  { id: 'prestations', label: 'Prestations & Services', icon: <CleaningServices /> }
];

export const galleryImages = [
  { id: 1, src: '/images/gallery/consultation.jpg', title: 'Consultation juridique', description: 'Experts à votre écoute' },
  { id: 2, src: '/images/gallery/immobilier.jpg', title: 'Transaction immobilière', description: 'Achat, vente, location' },
  { id: 3, src: '/images/gallery/recouvrement.jpg', title: 'Recouvrement de créances', description: 'Récupérez vos impayés' },
  { id: 4, src: '/images/gallery/dao.png', title: 'Marché Publique et Montage de dossiers DAO', description: 'Remportez vos appels d\'offres' },
  { id: 5, src: '/images/gallery/securite.png', title: 'Sécurité & Gardiennage', description: 'Protection 24h/24' },
  { id: 6, src: '/images/gallery/nettoyage.jpg', title: 'Nettoyage professionnel', description: 'Locaux impeccables' }
];

export const teamMembers = [
  {
    id: 1,
    name: 'Maître Kossi A. Mensah',
    role: 'Juriste Senior / Fondateur',
    bio: 'Expert en droit des affaires et en contentieux, avec plus de 15 ans d\'expérience au barreau du Togo.',
    avatar: '/images/team/team1.jpg',
    email: 'k.mensah@aujaagroup.com',
    linkedin: '#',
    twitter: '#'
  },
  {
    id: 2,
    name: 'Maître Adjoavi Sika',
    role: 'Avocate / Droit immobilier',
    bio: 'Spécialiste en droit immobilier et foncier. Accompagne les clients dans toutes leurs transactions immobilières.',
    avatar: '/images/team/team1.jpg',
    email: 'a.sika@aujaagroup.com',
    linkedin: '#',
    twitter: '#'
  },
  {
    id: 3,
    name: 'M. Yao Komlan',
    role: 'Expert en Marchés Publics',
    bio: 'Consultant certifié en marchés publics, spécialiste du montage de dossiers d\'appel d\'offres.',
    avatar: '/images/team/team1.jpg',
    email: 'y.komlan@aujaagroup.com',
    linkedin: '#',
    twitter: '#'
  },
  {
    id: 4,
    name: 'Mme Essi Tchala',
    role: 'Responsable Prestations',
    bio: 'Supervise les équipes de nettoyage, sécurité et logistique. Garantit la qualité des services rendus.',
    avatar: '/images/team/team1.jpg',
    email: 'e.tchala@aujaagroup.com',
    linkedin: '#',
    twitter: '#'
  }
];

export const achievements = [
  {
    id: 1,
    title: 'Transaction immobilière - Lomé',
    description: 'Vente d\'un terrain de 800m² à Tokoin - Transaction réussie en 30 jours',
    image: '/images/achievements/terrain-vendu-1.jpg',
    category: 'Immobilier',
    year: '2024'
  },
  {
    id: 2,
    title: 'Sinistre routier - Indemnisation',
    description: 'Accompagnement d\'une victime d\'accident - Indemnisation de 8.500.000 FCFA',
    image: '/images/achievements/sinistre-1.jpg',
    category: 'Assistance sinistre',
    year: '2024'
  },
  {
    id: 3,
    title: 'Immeuble R+3 - Adidogomé',
    description: 'Vente d\'un immeuble de 8 appartements - Transaction sécurisée',
    image: '/images/achievements/immeuble-vendu-1.jpg',
    category: 'Immobilier',
    year: '2023'
  },
  {
    id: 4,
    title: 'Recouvrement de créance',
    description: 'Récupération d\'une créance de 12.000.000 FCFA pour une entreprise',
    image: '/images/achievements/recouvrement-1.jpg',
    category: 'Recouvrement',
    year: '2024'
  },
  {
    id: 5,
    title: 'Appel d\'offres remporté',
    description: 'Montage de dossier DAO - Contrat de 150 millions FCFA',
    image: '/images/achievements/dao-1.jpg',
    category: 'Marchés publics',
    year: '2024'
  },
  {
    id: 6,
    title: 'Titre foncier obtenu',
    description: 'Immatriculation foncière pour un client - Parcelle à Agoè',
    image: '/images/achievements/titre-foncier-1.jpg',
    category: 'Formalités',
    year: '2023'
  }
];